/* pk-home.js: homepage behaviour for the pk-home-* sections (ported from the approved preview, remix/directions/slow-pour/patch.js).
   Vanilla, no libraries. Every section renders this file; it runs once. Re-binds on Customize section load/reorder.
   Motion inventory (all transform/opacity, all pausable, all static under reduced motion):
   prompt ribbon + word ticker (CSS keyframes, Pause buttons), the pinned brand statement (one passive scroll listener + rAF). */
(function () {
  if (window.__pkHome) return; window.__pkHome = true;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (RM) document.documentElement.classList.add('rx-rm');
  var q = function (r, s) { return r.querySelector(s); };
  var qa = function (r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); };

  /* brown-circle disclosures (native button, aria-expanded, panel hidden) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rx-disc]'); if (!b) return;
    var open = b.getAttribute('aria-expanded') !== 'true'; b.setAttribute('aria-expanded', open ? 'true' : 'false');
    var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = !open;
  });

  /* swipe carousel: scroll-snap track, Previous/Next + dots (aria-current), arrow keys / Home / End on the focused track.
     Where everything fits (desktop grid) the controls hide (is-scrollable off) and nothing moves. */
  function hcar(car) {
    if (car.__pk) return; car.__pk = true;
    var track = q(car, '[data-hc-track]'), list = track.firstElementChild, dots = q(car, '[data-hc-dots]'), prev = q(car, '[data-hc-prev]'), next = q(car, '[data-hc-next]'), cur = 0;
    var slides = Array.prototype.slice.call(list.children), tplGo = car.getAttribute('data-go-to') || 'Go to slide {i}: {name}';
    dots.innerHTML = '';
    slides.forEach(function (sl, i) { var d = document.createElement('button'); d.type = 'button'; d.className = 'rx-car__dot'; d.setAttribute('aria-label', tplGo.replace('{i}', i + 1).replace('{name}', sl.getAttribute('data-name') || '')); d.addEventListener('click', function () { go(i); }); dots.appendChild(d); });
    function scrollable() { return track.scrollWidth > track.clientWidth + 4; }
    function mark() {
      Array.prototype.forEach.call(dots.children, function (d, i) { if (i === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      prev.setAttribute('aria-disabled', cur <= 0 ? 'true' : 'false'); next.setAttribute('aria-disabled', cur >= slides.length - 1 ? 'true' : 'false');
      var sc = scrollable(); car.classList.toggle('is-scrollable', sc); if (sc) track.setAttribute('tabindex', '0'); else track.removeAttribute('tabindex');
    }
    function go(i) { cur = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: slides[cur].offsetLeft - list.offsetLeft - 16, behavior: RM ? 'auto' : 'smooth' }); mark(); }
    prev.addEventListener('click', function () { go(cur - 1); }); next.addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('keydown', function (e) { if (e.target !== track) return; var to = { ArrowRight: cur + 1, ArrowLeft: cur - 1, Home: 0, End: slides.length - 1 }[e.key]; if (to === undefined) return; e.preventDefault(); go(to); });
    var t = 0; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { var best = 0, bd = 1e9; slides.forEach(function (sl, i) { var dd = Math.abs(sl.offsetLeft - list.offsetLeft - 16 - track.scrollLeft); if (dd < bd) { bd = dd; best = i; } }); if (best !== cur) { cur = best; mark(); } }, 90); }, { passive: true });
    car.addEventListener('focusin', function (e) { var sl = e.target.closest && e.target.closest('[data-name]'); var i = slides.indexOf(sl); if (i >= 0 && i !== cur && scrollable()) go(i); });
    addEventListener('resize', mark, { passive: true }); mark();
  }

  /* Pause / Play for the ribbon and the ticker (paused from the start under reduced motion; paused off screen) */
  function motion(target) {
    var b = q(target, '.rx-motion-btn'); if (!b || b.__pk) return; b.__pk = true;
    var what = b.getAttribute('data-what') || '', tP = b.getAttribute('data-pause') || 'Pause', tPl = b.getAttribute('data-play') || 'Play';
    function set(paused) {
      target.classList.toggle('is-paused', paused); b.classList.toggle('is-paused', paused);
      b.setAttribute('aria-label', (paused ? tPl : tP) + ' ' + what);
      q(b, '.rx-motion-btn__txt').textContent = paused ? tPl : tP;
    }
    set(RM);
    b.addEventListener('click', function () { set(!target.classList.contains('is-paused')); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { target.classList.toggle('is-offscreen', !e.isIntersecting); }); }).observe(target);
  }
  function ribbon(flow) {
    var go = function () { requestAnimationFrame(function () { qa(flow, 'textPath').forEach(function (tp) { var path = flow.querySelector(tp.getAttribute('href')); if (path && path.getTotalLength) tp.setAttribute('textLength', path.getTotalLength().toFixed(1)); }); }); };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(go); else go();
  }

  /* Made for real life: Previous / Next step one card */
  function moments(sec) {
    var track = q(sec, '.rx-moments__track'), list = q(sec, '.rx-moments__list'); if (!track || track.__pk) return; track.__pk = true;
    var prev = q(sec, '.rx-arrow--prev'), next = q(sec, '.rx-arrow--next');
    function stepW() { var c = list.children; return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : track.clientWidth; }
    function sync() { var max = track.scrollWidth - track.clientWidth - 2; prev.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false'); next.setAttribute('aria-disabled', track.scrollLeft >= max ? 'true' : 'false'); }
    function go(dir) { track.scrollBy({ left: dir * stepW(), behavior: RM ? 'auto' : 'smooth' }); }
    prev.addEventListener('click', function () { go(-1); }); next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    addEventListener('resize', sync, { passive: true }); requestAnimationFrame(sync);
  }

  /* deck cards: "Try a few real cards" → Next card */
  function samples(w) {
    if (w.__pk) return; w.__pk = true;
    var cards = qa(w, '.rx-qcard'), cnt = q(w, '.rx-samples__count'), btn = q(w, '.rx-samples__next'), i = 0, n = cards.length, tpl = w.getAttribute('data-count') || '{i} of {n}';
    if (!btn || n < 2) return;
    btn.addEventListener('click', function () {
      cards[i].classList.remove('is-on'); cards[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % n;
      cards[i].classList.add('is-on'); cards[i].removeAttribute('aria-hidden');
      if (cnt) cnt.textContent = tpl.replace('{i}', i + 1).replace('{n}', n);
    });
  }

  /* pinned brand statement: the photo sharpens into a framed card as you scroll; static under reduced motion */
  function story(sec) {
    if (sec.__pk) return; sec.__pk = true;
    var soft = q(sec, '.rx-story__soft'), frame = q(sec, '.rx-story__frame');
    if (RM || !soft || !frame) { sec.classList.add('is-on', 'is-static'); return; }
    var ticking = false;
    var update = function () {
      ticking = false;
      var r = sec.getBoundingClientRect(), vh = innerHeight;
      var p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - vh)));
      soft.style.opacity = Math.min(1, p * 2.2).toFixed(3);
      frame.style.transform = 'scale(' + (0.94 + 0.06 * Math.min(1, p * 1.6)).toFixed(4) + ')';
      sec.classList.toggle('is-on', p > 0.28);
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', onScroll, { passive: true }); update();
  }

  /* shop-now pill: tucked while the site header is on screen, shown once it has scrolled away (inert while tucked) */
  function shopbar(bar) {
    if (bar.__pk) return; bar.__pk = true;
    var header = document.querySelector('.pdp-header') || document.querySelector('header');
    var ticking = false;
    var sync = function () {
      ticking = false;
      var hb = header ? header.getBoundingClientRect().bottom : 0;
      var tuck = hb > 0 || scrollY < 40;
      bar.classList.toggle('rx-tucked', tuck); bar.classList.toggle('is-shown', !tuck);
      if (tuck) bar.setAttribute('inert', ''); else bar.removeAttribute('inert');
    };
    var on = function () { if (!ticking) { ticking = true; requestAnimationFrame(sync); } };
    addEventListener('scroll', on, { passive: true }); addEventListener('resize', on, { passive: true }); sync();
    /* the sticky header hides/returns a frame AFTER the scroll event (pk-site.js), so also re-check when its class changes */
    var hs = header && header.closest('.shopify-section');
    if (hs && 'MutationObserver' in window) new MutationObserver(on).observe(hs, { attributes: true, attributeFilter: ['class'] });
    if (hs) hs.addEventListener('transitionend', on);
  }

  function init(root) {
    root = root || document;
    qa(root, '[data-hcar]').forEach(hcar);
    qa(root, '.rx-flow').forEach(function (f) { motion(f); ribbon(f); });
    qa(root, '.rx-ticker').forEach(motion);
    qa(root, '.rx-moments').forEach(moments);
    qa(root, '.rx-samples').forEach(samples);
    qa(root, '.rx-story').forEach(story);
    qa(root, '[data-pk-shopbar]').forEach(shopbar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
